import { HubJsonRpcRequest } from '../api/HubJsonRpcRequest';
import { HubApiMethods } from '../constants/HubApiMethods';
import { SendTicketResponse } from '../api/hub-responses/send-ticket-response';
import { SupportTicketRequestData } from './support-ticket-request-data';

export function sendSupportTicket(data: SupportTicketRequestData): Promise<boolean|string> {
    return HubJsonRpcRequest.makeRequest<SendTicketResponse, SupportTicketRequestData>(
        HubApiMethods.SEND_SUPPORT_MESSAGE,
        data,
        window.app.deviceIdentifier
    )
        .then((response) => {
            if (response !== 1) {
                return 'Bad response';
            }

            return true;
        })
        .catch((error) => error.message);
}
